// extracted by css-extract-rspack-plugin
var _1 = "sI9TJKxh1CMfTs5_";
var _2 = "raPjgwHEdhAUJkhC";
var _3 = "ycIQ9dF5uUwMPm0y";
var _4 = "OdFkHse9XS0SBq2Y";
var _5 = "NLmX9b_278oZvPgL";
export { _1 as "btn", _2 as "floating", _3 as "panel", _4 as "show", _5 as "text" }
